// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type Anbauteil, AnbauteilDaten } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useUpdateAnbauteil(): (
  anbauteilId: string,
  requestBody: AnbauteilDaten
) => Promise<Anbauteil> {
  const getAPI = useGetApi();
  return useCallback(
    async (anbauteilId, requestBody) =>
      (await getAPI()).anbauteile.updateAnbauteil({ anbauteilId, requestBody }),
    [getAPI]
  );
}
